import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_providers/HomeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/utils/variables.module.scss");
